// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box, Button, Typography, Grid, TableContainer, Table, TableHead, TableBody,
//   Paper, Select, MenuItem, FormControl, InputLabel, TextField, TablePagination,
//   DialogContent,
// } from '@mui/material';
// import { BootstrapDialog, BootstrapDialogTitle, Breadcrumb, StyledTableCell, StyledTableRow } from '../../reusableComponent/Reusables';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useForm, Controller } from 'react-hook-form';
// import { Print } from '@mui/icons-material';
// import styles from '../../../styles.module.css';
// import dayjs from 'dayjs';
// import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// import deliveryChallanService from '../../../services/deliveryChallan.Service';

// const ChallanReport = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;
//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;

//   const [successMessage, setSuccessMessage] = useState('');
//   const [displayData, setDisplayData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filterType, setFilterType] = useState('');
//   const [subBoxOptions, setSubBoxOptions] = useState([]);
//   const [subBoxValue, setSubBoxValue] = useState('');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [info, setInfo] = useState([]);
//   const [openDetail, setDetail] = useState(false);

//   const { control, watch, formState: { errors }, setError, setValue } = useForm({
//     defaultValues: {
//       entry_date_from: editData?.entry_date ? dayjs(editData.entry_date).format('YYYY-MM-DD') : '',
//       entry_date_to: editData?.entry_date ? dayjs(editData.entry_date).format('YYYY-MM-DD') : '',
//       filterType: '',
//       subBox: '',
//     },
//   });

//   const entryDateFrom = watch('entry_date_from');
//   const entryDateTo = watch('entry_date_to');
//   const selectedFilterType = watch('filterType');

//   const filterOptions = [
//     { value: 'Customer', label: 'Customer' },
//     { value: 'Depot', label: 'Depot' },
//     { value: 'Status', label: 'Status' },
//     { value: 'Product', label: 'Product' },
//   ];

//   const fetchSubBoxOptions = useCallback(async (filterType, data) => {
//     try {
//       let options = [];
//       switch (filterType) {
//         case 'Customer':
//           options = [...new Set(data.map(item => item.to_customer_name))].filter(Boolean)
//             .map(name => ({ value: name, label: name }));
//           break;
//         case 'Depot':
//           options = [...new Set(data.map(item => item.from_depot_name))].filter(Boolean)
//             .map(name => ({ value: name, label: name }));
//           break;
//         case 'Status':
//           const statuses = data.flatMap(item => {
//             try {
//               const details = JSON.parse(item.table_details || '[]');
//               return details.map(d => d.status);
//             } catch { return []; }
//           });
//           options = [...new Set(statuses)].filter(Boolean).map(s => ({ value: s, label: s }));
//           break;
//         case 'Product':
//           options = [...new Set(data.map(item => item.prod_code))].filter(Boolean)
//             .map(code => ({ value: code, label: code }));
//           break;
//         default:
//           options = [];
//       }
//       setSubBoxOptions(options);
//       setSubBoxValue('');
//       setValue('subBox', '');
//     } catch (error) {
//       console.error(error);
//       setSuccessMessage('Error loading filter options');
//     }
//   }, [setValue]);

//   useEffect(() => {
//     const fetchInitial = async () => {
//       if (!entryDateFrom || !entryDateTo || !selectedFilterType) return;
//       try {
//         const res = await deliveryChallanService.getChallanReport({
//           page: 0,
//           size: 999,
//           searchKey: '',
//           fromDate: entryDateFrom,
//           toDate: entryDateTo,
//         });
//         const data = res?.data || res || [];
//         fetchSubBoxOptions(selectedFilterType, data);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchInitial();
//   }, [selectedFilterType, entryDateFrom, entryDateTo, fetchSubBoxOptions]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleShow = useCallback(async (formData) => {
//     const { entry_date_from, entry_date_to, filterType, subBox } = formData;
//     if (!entry_date_from) return setError('entry_date_from', { message: 'From Date is required' });
//     if (!entry_date_to) return setError('entry_date_to', { message: 'To Date is required' });
//     if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
//       return setError('entry_date_to', { message: 'To Date cannot be before From Date' });
//     }

//     try {
//       setLoading(true);
//       setDisplayData([]);
//       const res = await deliveryChallanService.getChallanReport({
//         page,
//         size: rowsPerPage,
//         searchKey: '',
//         fromDate: entry_date_from,
//         toDate: entry_date_to,
//       });
//       let fetchedData = res?.data || res || [];

//       if (filterType && subBox) {
//         fetchedData = fetchedData.filter(item => {
//           if (filterType === 'Customer') return item.to_customer_name === subBox;
//           if (filterType === 'Depot') return item.from_depot_name === subBox;
//           if (filterType === 'Status') {
//             try {
//               const details = JSON.parse(item.table_details || '[]');
//               return details.some(d => d.status === subBox);
//             } catch { return false; }
//           }
//           if (filterType === 'Product') return item.prod_code === subBox;
//           return true;
//         });
//       }
//       setDisplayData(fetchedData);
//     } catch (error) {
//       console.error(error);
//       setDisplayData([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [setError, page, rowsPerPage]);

//   useEffect(() => {
//     if (entryDateFrom && entryDateTo && !errors.entry_date_from && !errors.entry_date_to) {
//       handleShow({
//         entry_date_from: entryDateFrom,
//         entry_date_to: entryDateTo,
//         filterType: selectedFilterType,
//         subBox: subBoxValue,
//       });
//     }
//   }, [entryDateFrom, entryDateTo, selectedFilterType, subBoxValue, page, rowsPerPage, errors, handleShow]);

//   // PERFECT PRINT FUNCTION - NO SCROLLING GUARANTEED
//   const handlePrint = () => {
//     const printWindow = window.open('', '_blank', 'width=1000,height=800');

//     const printCSS = `
//       <style>
//         body { margin: 0; padding: 15mm; font-family: Arial, sans-serif; }
//         @page { size: A4 portrait; margin: 10mm; }
//         @media print {
//           body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//           .page-break { page-break-before: always; }
//         }
//         h2 { text-align: center; margin: 0 0 20px 0; font-size: 18px; }
//         .header-info { margin-bottom: 20px; font-size: 12px; }
//         table { width: 100%; border-collapse: collapse; font-size: 10px; margin-top: 10px; }
//         th, td { border: 1px solid #333; padding: 6px; text-align: center; }
//         th { background-color: #f0f0f0 !important; font-weight: bold; }
//         thead { display: table-header-group; }
//         tbody tr { page-break-inside: avoid; }
//         .cancelled { color: red; font-weight: bold; }
//       </style>
//     `;

//     let printContent = '';

//     if (openDetail && info.length > 0) {
//       // Print Cylinder Details
//       printContent = `
//         <h2>Delivery Challan - Cylinder Details</h2>
//         <table>
//           <thead>
//             <tr>
//               <th>Sr No</th><th>Cylinder No</th><th>Tag No</th><th>Actual Qty</th><th>Bill Qty</th><th>UOM</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${info.map((row, i) => `
//               <tr>
//                 <td>${i + 1}</td>
//                 <td>${row.cyl_no || ''}</td>
//                 <td>${row.tag_no || ''}</td>
//                 <td>${row.qty || ''}</td>
//                 <td>${row.bill_qty || ''}</td>
//                 <td>${row.uom || ''}</td>
//               </tr>
//             `).join('')}
//           </tbody>
//         </table>
//       `;
//     } else {
//       // Print Main Report
//       printContent = `
//         <h2>DELIVERY CHALLAN REPORT</h2>
//         <div class="header-info">
//           <strong>From Date:</strong> ${entryDateFrom || 'N/A'} &nbsp;&nbsp;&nbsp;
//           <strong>To Date:</strong> ${entryDateTo || 'N/A'}
//         </div>
//         <table>
//           <thead>
//             <tr>
//               <th>Sr No</th><th>Challan No</th><th>Challan Date</th><th>PO No</th><th>PO Date</th>
//               <th>Invoice No</th><th>SO No</th><th>SO Date</th><th>To Party</th><th>Driver Name</th>
//               <th>Vehicle No</th><th>Flag</th><th>No of Cyl</th><th>Depot Name</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${displayData.map((row, index) => `
//               <tr>
//                 <td>${index + 1}</td>
//                 <td>${row.entry_no}</td>
//                 <td>${dateConversion(row.entry_date)}</td>
//                 <td>${row.po_no || 'N/A'}</td>
//                 <td>${dateConversion(row.po_date) || 'N/A'}</td>
//                 <td>${row.invoice_no || ''}</td>
//                 <td>${row.so_no || 'N/A'}</td>
//                 <td>${dateConversion(row.so_date) || 'N/A'}</td>
//                 <td>${row.to_depot_name || row.to_customer_name || ''}</td>
//                 <td>${row.driver_name || ''}</td>
//                 <td>${row.vehicle_no || ''}</td>
//                 <td class="${row.update_check === 1 ? 'cancelled' : ''}">
//                   ${row.update_check === 1 ? 'Cancelled' : ''}
//                 </td>
//                 <td>${JSON.parse(row.table_details || '[]').length}</td>
//                 <td>${row.from_depot_name || ''}</td>
//               </tr>
//             `).join('')}
//           </tbody>
//         </table>
//       `;
//     }

//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html><head><meta charset="utf-8"><title>Delivery Challan Report</title>
//       ${printCSS}
//       </head><body>${printContent}</body></html>
//     `);
//     printWindow.document.close();
//     printWindow.focus();
//     setTimeout(() => {
//       printWindow.print();
//       // printWindow.close();  // agar auto close chahiye to uncomment karo
//     }, 500);
//   };

//   const handleDetails = (tableData) => {
//     try {
//       const parsed = JSON.parse(tableData || '[]');
//       setInfo(parsed);
//       setDetail(true);
//     } catch (err) {
//       console.error(err);
//       setSuccessMessage('Error loading details');
//     }
//   };

//   const handleClose = () => {
//     setDetail(false);
//     setInfo([]);
//   };

//   const dateConversion = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     const dd = String(d.getDate()).padStart(2, '0');
//     const mm = String(d.getMonth() + 1).padStart(2, '0');
//     const yyyy = d.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   return (
//     <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: ' Delivery Challan Report' }]} />
//         <Typography className={styles.header_txt}>DELIVERY CHALLAN REPORT</Typography>

//         <form className="no-print">
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>From Date</Typography>
//                 <Controller name="entry_date_from" control={control} render={({ field }) => (
//                   <TextField {...field} size="small" type="date" fullWidth InputLabelProps={{ shrink: true }}
//                     error={!!errors.entry_date_from} helperText={errors.entry_date_from?.message} sx={{ ml: 1 }} />
//                 )} />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>To Date</Typography>
//                 <Controller name="entry_date_to" control={control} render={({ field }) => (
//                   <TextField {...field} size="small" type="date" fullWidth InputLabelProps={{ shrink: true }}
//                     error={!!errors.entry_date_to} helperText={errors.entry_date_to?.message} sx={{ ml: 1 }} />
//                 )} />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>Filter By</Typography>
//                 <Controller name="filterType" control={control} render={({ field }) => (
//                   <FormControl fullWidth size="small" sx={{ ml: 1 }}>
//                     <Select {...field} onChange={(e) => { field.onChange(e); setFilterType(e.target.value); }}>
//                       <MenuItem value=""><em>Select Filter</em></MenuItem>
//                       {filterOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
//                     </Select>
//                   </FormControl>
//                 )} />
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>Sub Filter</Typography>
//                 <Controller name="subBox" control={control} render={({ field }) => (
//                   <FormControl fullWidth size="small" disabled={!filterType} sx={{ ml: 1 }}>
//                     <Select {...field} onChange={(e) => { field.onChange(e); setSubBoxValue(e.target.value); }}>
//                       <MenuItem value=""><em>Select Option</em></MenuItem>
//                       {subBoxOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
//                     </Select>
//                   </FormControl>
//                 )} />
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         <Grid item xs={12}>
//           <Paper sx={{ width: '100%' }}>
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }} className="no-print">
//               <Button variant="outlined" startIcon={<Print />} onClick={handlePrint} disabled={displayData.length === 0}>
//                 {openDetail ? 'Print Details' : 'Print Report'}
//               </Button>
//             </Box>

//             <div className="printable-area">
//               <TableContainer component={Paper}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <StyledTableRow>
//                       <StyledTableCell align="center">Sr No</StyledTableCell>
//                       <StyledTableCell>Challan No</StyledTableCell>
//                       <StyledTableCell>Challan Date</StyledTableCell>
//                       <StyledTableCell>PO No</StyledTableCell>
//                       <StyledTableCell>PO Date</StyledTableCell>
//                       <StyledTableCell>Invoice No</StyledTableCell>
//                       <StyledTableCell>SO No</StyledTableCell>
//                       <StyledTableCell>SO Date</StyledTableCell>
//                       <StyledTableCell>To Party</StyledTableCell>
//                       <StyledTableCell>Driver Name</StyledTableCell>
//                       <StyledTableCell>Vehicle No</StyledTableCell>
//                       <StyledTableCell>Flag</StyledTableCell>
//                       <StyledTableCell>No of Cyl</StyledTableCell>
//                       <StyledTableCell>Depot Name</StyledTableCell>
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody>
//                     {loading ? (
//                       <StyledTableRow><StyledTableCell colSpan={14} align="center">Loading...</StyledTableCell></StyledTableRow>
//                     ) : displayData.length === 0 ? (
//                       <StyledTableRow><StyledTableCell colSpan={14} align="center">No data found</StyledTableCell></StyledTableRow>
//                     ) : (
//                       displayData
//                         .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                         .map((row, index) => (
//                           <StyledTableRow key={index}>
//                             <StyledTableCell align="center">{page * rowsPerPage + index + 1}</StyledTableCell>
//                             <StyledTableCell>{row.entry_no}</StyledTableCell>
//                             <StyledTableCell>{dateConversion(row.entry_date)}</StyledTableCell>
//                             <StyledTableCell>{row.po_no || 'N/A'}</StyledTableCell>
//                             <StyledTableCell>{dateConversion(row.po_date)}</StyledTableCell>
//                             <StyledTableCell>{row.invoice_no}</StyledTableCell>
//                             <StyledTableCell>{row.so_no || 'N/A'}</StyledTableCell>
//                             <StyledTableCell>{dateConversion(row.so_date)}</StyledTableCell>
//                             <StyledTableCell>{row.to_depot_name || row.to_customer_name}</StyledTableCell>
//                             <StyledTableCell>{row.driver_name}</StyledTableCell>
//                             <StyledTableCell>{row.vehicle_no}</StyledTableCell>
//                             <StyledTableCell isCancelled={row.update_check === 1}>
//                               {row.update_check === 1 ? 'Cancelled' : ''}
//                             </StyledTableCell>
//                             <StyledTableCell align="center" sx={{ color: 'blue', cursor: 'pointer', fontWeight: 'bold' }}
//                               onClick={() => handleDetails(row.table_details)}>
//                               {JSON.parse(row.table_details || '[]').length}
//                             </StyledTableCell>
//                             <StyledTableCell>{row.from_depot_name}</StyledTableCell>
//                           </StyledTableRow>
//                         ))
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//               <TablePagination
//                 className="no-print"
//                 rowsPerPageOptions={[10, 25, 100]}
//                 component="div"
//                 count={displayData.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               />
//             </div>
//           </Paper>
//         </Grid>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage('')}
//           message={successMessage}
//           autoHideDuration={3000}
//           vertical="top"
//           horizontal="right"
//         />

//         <BootstrapDialog open={openDetail} onClose={handleClose} maxWidth="md" fullWidth>
//           <BootstrapDialogTitle onClose={handleClose}>Cylinder Details</BootstrapDialogTitle>
//           <DialogContent dividers>
//             <TableContainer>
//               <Table size="small">
//                 <TableHead>
//                   <StyledTableRow>
//                     <StyledTableCell align="center">Sr No</StyledTableCell>
//                     <StyledTableCell>Cylinder No</StyledTableCell>
//                     <StyledTableCell>Tag No</StyledTableCell>
//                     <StyledTableCell>Actual Qty</StyledTableCell>
//                     <StyledTableCell>Bill Qty</StyledTableCell>
//                     <StyledTableCell>UOM</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody>
//                   {info.map((row, i) => (
//                     <StyledTableRow key={i}>
//                       <StyledTableCell align="center">{i + 1}</StyledTableCell>
//                       <StyledTableCell>{row.cyl_no}</StyledTableCell>
//                       <StyledTableCell>{row.tag_no}</StyledTableCell>
//                       <StyledTableCell>{row.qty}</StyledTableCell>
//                       <StyledTableCell>{row.bill_qty}</StyledTableCell>
//                       <StyledTableCell>{row.uom}</StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </BootstrapDialog>
//       </Box>
//     </Box>
//   );
// };

// export default ChallanReport;

import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Button, Typography, Grid, TableContainer, Table, TableHead, TableBody,
  Paper, MenuItem, DialogContent, Dialog, IconButton,
} from '@mui/material';
import {
  Breadcrumb, CTSRinput, StyledTableCell, StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import deliveryChallanService from '../../../services/deliveryChallan.Service';
import CustomPagination from '../../reusableComponent/CustomPagination';
import { useSelector } from 'react-redux';

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }
    .printable-table thead { display: table-header-group; }
    .printable-table tbody { display: table-row-group; }
    .MuiPaper-root, .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }
    .no-print { display: none !important; }
    .print-header-info { display: block !important; margin-bottom: 10px; }
  }
  .print-header-info { display: none; }
`;

const ChallanReport = () => {
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const defaultRowsPerPage = useSelector(state => state.delivery_challan?.rows_per_page || 15);

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subBoxOptions, setSubBoxOptions] = useState([]);
  const [subBoxValue, setSubBoxValue] = useState('');
  const [info, setInfo] = useState([]);
  const [openDetail, setDetail] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const { control, watch, formState: { errors }, setError, setValue } = useForm({
    defaultValues: {
      entry_date_from: editData?.entry_date
    ? dayjs(editData.entry_date).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD"),        // ← today
  entry_date_to: dayjs().format("YYYY-MM-DD"),  // ← today
      filterType: '',
      subBox: '',
    },
  });

  const entryDateFrom = watch('entry_date_from');
  const entryDateTo = watch('entry_date_to');
  const selectedFilterType = watch('filterType');

  const effectiveTotalCount = totalCount > 0 ? totalCount : displayData.length;

  const filterOptions = [
    { value: 'Customer', label: 'Customer' },
    { value: 'Depot', label: 'Depot' },
    { value: 'Status', label: 'Status' },
    { value: 'Product', label: 'Product' },
  ];

  // ── Effect 1: Print styles ────────────────────────────────────────────────
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  // ── Effect 2: Reset page when filters change ─────────────────────────────
  useEffect(() => {
    setController(prev => ({ ...prev, page: 0 }));
  }, [entryDateFrom, entryDateTo, selectedFilterType, subBoxValue]);

  // ── Fetch sub-filter options ──────────────────────────────────────────────
  const fetchSubBoxOptions = useCallback(async (filterType, data) => {
    try {
      let options = [];
      switch (filterType) {
        case 'Customer':
          options = [...new Set(data.map(item => item.to_customer_name))].filter(Boolean)
            .map(name => ({ value: name, label: name }));
          break;
        case 'Depot':
          options = [...new Set(data.map(item => item.from_depot_name))].filter(Boolean)
            .map(name => ({ value: name, label: name }));
          break;
        case 'Status':
          const statuses = data.flatMap(item => {
            try { return JSON.parse(item.table_details || '[]').map(d => d.status); }
            catch { return []; }
          });
          options = [...new Set(statuses)].filter(Boolean).map(s => ({ value: s, label: s }));
          break;
        case 'Product':
          options = [...new Set(data.map(item => item.prod_code))].filter(Boolean)
            .map(code => ({ value: code, label: code }));
          break;
        default:
          options = [];
      }
      setSubBoxOptions(options);
      setSubBoxValue('');
      setValue('subBox', '');
    } catch (error) {
      console.error(error);
      setSuccessMessage('Error loading filter options');
    }
  }, [setValue]);

  useEffect(() => {
    const fetchInitial = async () => {
      if (!entryDateFrom || !entryDateTo || !selectedFilterType) return;
      try {
        const res = await deliveryChallanService.getChallanReport({
          page: 0, size: 999, searchKey: '',
          fromDate: entryDateFrom, toDate: entryDateTo,
        });
        const data = res?.data || res || [];
        fetchSubBoxOptions(selectedFilterType, data);
      } catch (err) { console.error(err); }
    };
    fetchInitial();
  }, [selectedFilterType, entryDateFrom, entryDateTo, fetchSubBoxOptions]);

  // ── Fetch main data ───────────────────────────────────────────────────────
  const handleShow = useCallback(async (formData) => {
    const { entry_date_from, entry_date_to, filterType, subBox } = formData;
    if (!entry_date_from) { setError('entry_date_from', { message: 'From Date is required' }); return; }
    if (!entry_date_to) { setError('entry_date_to', { message: 'To Date is required' }); return; }
    if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
      setError('entry_date_to', { message: 'To Date cannot be before From Date' }); return;
    }
    try {
      setLoading(true);
      setDisplayData([]);
      const res = await deliveryChallanService.getChallanReport({
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: '',
        fromDate: entry_date_from,
        toDate: entry_date_to,
      });
      let fetchedData = res?.data || res || [];
      const total = res?.total_count ?? res?.totalCount ?? res?.count ?? fetchedData.length;

      if (filterType && subBox) {
        fetchedData = fetchedData.filter(item => {
          if (filterType === 'Customer') return item.to_customer_name === subBox;
          if (filterType === 'Depot') return item.from_depot_name === subBox;
          if (filterType === 'Status') {
            try { return JSON.parse(item.table_details || '[]').some(d => d.status === subBox); }
            catch { return false; }
          }
          if (filterType === 'Product') return item.prod_code === subBox;
          return true;
        });
      }
      setDisplayData(fetchedData);
      setTotalCount(total);
    } catch (error) {
      console.error(error);
      setDisplayData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, [setError, controller.page, controller.rowsPerPage]);

  useEffect(() => {
    if (entryDateFrom && entryDateTo && !errors.entry_date_from && !errors.entry_date_to) {
      handleShow({
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
        filterType: selectedFilterType,
        subBox: subBoxValue,
      });
    }
  }, [entryDateFrom, entryDateTo, selectedFilterType, subBoxValue, controller.page, controller.rowsPerPage]);

  const handleChangePage = (event, newPage) => setController(prev => ({ ...prev, page: newPage }));
  const handleChangeRowsPerPage = (event) => setController({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  const handlePrint = () => { window.print(); };

  // ── Challan No click → open detail dialog ────────────────────────────────
  const handleDetails = (row) => {
    setSelectedRow(row);
    try { setInfo(JSON.parse(row.table_details || '[]')); } catch { setInfo([]); }
    setDetail(true);
  };
  const handleClose = () => { setDetail(false); setSelectedRow(null); setInfo([]); };

  const dateConversion = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const cylinderHeaders = ['Sr No', 'Cylinder No', 'Tag No', 'Actual Qty', 'Bill Qty', 'UOM'];

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'Delivery Challan Report' }]} />
        <Typography className={styles.header_txt}>DELIVERY CHALLAN SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', mb: 2, width: '100%' }}
        >
          {/* From Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              From Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="entry_date_from" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date_from} helperText={errors.entry_date_from?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          {/* To Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              To Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller name="entry_date_to" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date_to} helperText={errors.entry_date_to?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          {/* Filter By */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              Filter By
            </Typography>
            <Controller name="filterType" control={control} render={({ field }) => (
              <CTSRinput select size="small" fullWidth {...field}
                onChange={(e) => { field.onChange(e); }}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value=""><em>Select Filter</em></MenuItem>
                {filterOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
              </CTSRinput>
            )} />
          </Box>

          {/* Sub Filter */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px', minWidth: '150px', maxWidth: { xs: '100%', sm: '220px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              Sub Filter
            </Typography>
            <Controller name="subBox" control={control} render={({ field }) => (
              <CTSRinput select size="small" fullWidth {...field}
                disabled={!selectedFilterType}
                onChange={(e) => { field.onChange(e); setSubBoxValue(e.target.value); }}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                <MenuItem value=""><em>Select Option</em></MenuItem>
                {subBoxOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
              </CTSRinput>
            )} />
          </Box>

          {/* Print Button */}
          <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: '0 0 auto', ml: { xs: 'auto', sm: 0 } }}>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={displayData.length === 0} size="small"
              sx={{ whiteSpace: 'nowrap', height: '30px' }}
            >
              Print
            </Button>
          </Box>
        </Box>

        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: '100%' }}>
            <div className="printable-area">
              <div className="print-header-info" style={{ marginBottom: '20px' }}>
                <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>Delivery Challan Report</Typography>
                <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
                  From: {dateConversion(entryDateFrom)} &nbsp;|&nbsp; To: {dateConversion(entryDateTo)}
                </Typography>
              </div>

              <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      {['Sr No', 'Challan No', 'Challan Date', 'PO No', 'PO Date',
                        'Invoice No', 'SO No', 'SO Date', 'To Party', 'Driver Name',
                        'Vehicle No', 'Flag', 'No of Cyl', 'Depot Name'].map((h) => (
                        <StyledTableCell key={h} sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
                          {h}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {loading ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={14} align="center"><Typography>Loading data...</Typography></StyledTableCell>
                      </StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={14} align="center"><Typography>No data found</Typography></StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      displayData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                            {controller.page * controller.rowsPerPage + index + 1}
                          </StyledTableCell>

                          {/* Challan No — clickable */}
                          <StyledTableCell onClick={() => handleDetails(row)}>
                            <Typography sx={{
                              fontSize: '12px', fontWeight: 'bold', cursor: 'pointer',
                              color: '#1976d2 !important', textDecoration: 'underline',
                            }}>
                              {row.entry_no}
                            </Typography>
                          </StyledTableCell>

                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.entry_date)}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.po_no || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.po_date) || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.invoice_no || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.so_no || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.so_date) || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.to_depot_name || row.to_customer_name || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.driver_name || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.vehicle_no || 'N/A'}</StyledTableCell>
                          <StyledTableCell
                            className={styles.inspection_cell}
                            sx={{ color: row.update_check === 1 ? 'red' : 'inherit', fontWeight: row.update_check === 1 ? 'bold' : 'normal' }}
                          >
                            {row.update_check === 1 ? 'Cancelled' : ''}
                          </StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell} align="left">
                            {JSON.parse(row.table_details || '[]').length}
                          </StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.from_depot_name || 'N/A'}</StyledTableCell>
                        </StyledTableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={effectiveTotalCount || 0}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage('')}
          message={successMessage}
          autoHideDuration={3000}
          vertical="top"
          horizontal="right"
          className="no-print"
        />

        {/* ── Detail Dialog ── */}
        <Dialog
          open={openDetail}
          onClose={handleClose}
          maxWidth={false}
          className="no-print"
          sx={{
            '& .MuiDialog-paper': {
              margin: 'auto', width: '92vw', maxHeight: '85vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              overflow: 'hidden', fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: '#1C3A5E', padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#fff', letterSpacing: '0.5px', fontFamily: "'Inter', Arial, sans-serif" }}>
              DELIVERY CHALLAN DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: '20px 24px', background: '#F4F7FB', overflowY: 'auto' }}>

            {/* ── Challan Info Card ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden', mb: 2.5 }}>
              <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 Challan Information
                </Typography>
              </Box>
              <Grid container>
                {[
                  { label: 'Challan No',      value: selectedRow?.entry_no,                                          border: true,  bottom: true },
                  { label: 'Challan Date',    value: dateConversion(selectedRow?.entry_date),                        border: true,  bottom: true },
                  { label: 'PO No',           value: selectedRow?.po_no,                                             border: true,  bottom: true },
                  { label: 'PO Date',         value: dateConversion(selectedRow?.po_date),                           border: false, bottom: true },
                  { label: 'Invoice No',      value: selectedRow?.invoice_no,                                        border: true,  bottom: true },
                  { label: 'SO No',           value: selectedRow?.so_no,                                             border: true,  bottom: true },
                  { label: 'SO Date',         value: dateConversion(selectedRow?.so_date),                           border: true,  bottom: true },
                  { label: 'To Party',        value: selectedRow?.to_depot_name || selectedRow?.to_customer_name,    border: false, bottom: true },
                  { label: 'Driver Name',     value: selectedRow?.driver_name,                                       border: true,  bottom: false },
                  { label: 'Vehicle No',      value: selectedRow?.vehicle_no,                                        border: true,  bottom: false },
                  { label: 'Depot Name',      value: selectedRow?.from_depot_name,                                   border: true,  bottom: false },
                  { label: 'Status',          value: selectedRow?.update_check === 1 ? 'Cancelled' : 'Active',      border: false, bottom: false },
                ].map(({ label, value, border, bottom }) => (
                  <Grid
                    key={label} item xs={12} sm={6} md={3}
                    sx={{
                      borderRight: border ? '1px solid #EDF2F7' : 'none',
                      borderBottom: bottom ? '1px solid #EDF2F7' : 'none',
                      padding: '12px 16px',
                    }}
                  >
                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      {label}
                    </Typography>
                    <Typography sx={{
                      fontSize: '14px',
                      fontWeight: label === 'Challan No' ? 700 : 600,
                      color: label === 'Challan No' ? '#1C3A5E' : label === 'Status' && value === 'Cancelled' ? '#E53E3E' : '#2D3748',
                      fontFamily: "'Inter', Arial, sans-serif",
                    }}>
                      {value || 'N/A'}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              {/* <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  🛢️ Cylinder Details
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: '350px' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map((header) => (
                        <StyledTableCell
                          key={header} align="center"
                          sx={{
                            backgroundColor: '#1C3A5E !important',
                            color: '#fff !important',
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700, fontSize: '11px',
                            padding: '10px 8px', whiteSpace: 'nowrap',
                            borderRight: '1px solid rgba(255,255,255,0.1)',
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {info.length > 0 ? (
                      info.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F8FAFC', '&:hover': { backgroundColor: '#EBF4FF' } }}
                        >
                          {[
                            index + 1,
                            row.cyl_no   || 'N/A',
                            row.tag_no   || 'N/A',
                            row.qty      || 'N/A',
                            row.bill_qty || 'N/A',
                            row.uom      || 'N/A',
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci} align="center"
                              sx={{ fontSize: '11px', fontFamily: "'Inter', Arial, sans-serif", color: '#2D3748', padding: '8px 6px', borderBottom: '1px solid #EDF2F7', whiteSpace: 'nowrap' }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={cylinderHeaders.length} align="center"
                          sx={{ py: 5, fontSize: '13px', color: '#A0AEC0', fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: '12px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={handleClose}
              sx={{
                background: '#E53E3E', color: '#fff', fontSize: '13px', fontWeight: 600,
                textTransform: 'none', padding: '7px 20px', borderRadius: '8px',
                fontFamily: "'Inter', Arial, sans-serif",
                '&:hover': { background: '#971f16' },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

      </Box>
    </Box>
  );
};

export default ChallanReport;